(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["rematchDefaultReducers"] = factory();
	else
		root["rematchDefaultReducers"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDefaultReducers = void 0;

var _mapObjIndexed2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/mapObjIndexed */ "ramda/src/mapObjIndexed"));

var _mergeDeepRight2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/mergeDeepRight */ "ramda/src/mergeDeepRight"));

var _converge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/converge */ "ramda/src/converge"));

var _applyTo2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/applyTo */ "ramda/src/applyTo"));

var _merge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/merge */ "ramda/src/merge"));

var _objOf2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/objOf */ "ramda/src/objOf"));

var _identity2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/identity */ "ramda/src/identity"));

var _prop2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/prop */ "ramda/src/prop"));

var _always2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/always */ "ramda/src/always"));

var _flip2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/flip */ "ramda/src/flip"));

var _isNil2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/isNil */ "ramda/src/isNil"));

var _both2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/both */ "ramda/src/both"));

var _is2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/is */ "ramda/src/is"));

var _anyPass2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/anyPass */ "ramda/src/anyPass"));

var _type2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/type */ "ramda/src/type"));

var _equals2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/equals */ "ramda/src/equals"));

var _o2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/o */ "ramda/src/o"));

var _cond2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/cond */ "ramda/src/cond"));

var _useWith2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/useWith */ "ramda/src/useWith"));

var _pipe2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/pipe */ "ramda/src/pipe"));

var _handleStateArray =
/*#__PURE__*/
__webpack_require__(/*! ./lib/handleStateArray */ "./src/lib/handleStateArray.js");

var _handleStateObj =
/*#__PURE__*/
__webpack_require__(/*! ./lib/handleStateObj */ "./src/lib/handleStateObj.js");

var _handleStatePrimitives =
/*#__PURE__*/
__webpack_require__(/*! ./lib/handleStatePrimitives */ "./src/lib/handleStatePrimitives.js");

var _utils =
/*#__PURE__*/
__webpack_require__(/*! ./lib/utils */ "./src/lib/utils.js");

var _utils2 =
/*#__PURE__*/
__webpack_require__(/*! ./lib/utils.obj */ "./src/lib/utils.obj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * :: opts -> (model, modelName -> modelWithDefaultReducers)
 *
 * @function createReducersFromModel
 * @param {{allowNil?: boolean}} opts
 * @param {{ state: {attr}, reducers?: {[key: string]: function}}} model
 * @param {string} modelName
 * @returns {reducers: {[key: string]: function}} model reducers
 */
var createReducersFromModel = function createReducersFromModel(opts) {
  return (0, _pipe2.default)((0, _useWith2.default)((0, _cond2.default)([[_utils2.isVanillaObj, (0, _handleStateObj.handleInitialStateObject)(opts)], [(0, _o2.default)((0, _equals2.default)('Array'), _type2.default), (0, _handleStateArray.handleInitialStateArray)(opts)], [(0, _anyPass2.default)([(0, _is2.default)(String), (0, _is2.default)(Number), (0, _is2.default)(Boolean)]), (0, _handleStatePrimitives.handleInitialStateOther)(opts)], [(0, _both2.default)(_isNil2.default, function () {
    return !opts.allowNil;
  }), (0, _flip2.default)(_utils._handleNil)], [(0, _always2.default)(true), (0, _handleStatePrimitives.handleInitialStateOther)(opts)]]), [(0, _prop2.default)('state'), _identity2.default]), (0, _objOf2.default)('reducers'));
};
/**
 * Takes a the `models` object for @rematch/core and decorates each model
 * with default reducers/actions generated from each models' inital state
 * @public
 * @function withDefaultReducers
 * @param {{
    [modelName: string]: {
      state,
      reducers?: {
        [actionName: string]: function
      }
    }
  }} models
 * @param {{allowNil: boolean, typeCheck: boolean}} opts
 * @returns {{model: {state, reducers: {[actionName: string]: function}}}}
 */


var withDefaultReducers = function withDefaultReducers(models) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _opts = (0, _merge2.default)({
    allowNil: false,
    typeCheck: true
  }, opts);

  return (0, _applyTo2.default)(models)((0, _pipe2.default)((0, _converge2.default)(_mergeDeepRight2.default, [(0, _mapObjIndexed2.default)(createReducersFromModel(_opts)), _identity2.default]), (0, _mergeDeepRight2.default)({
    rootState: {
      reducers: {
        reset: _identity2.default,
        set: _identity2.default
      },
      state: null
    }
  })));
};

exports.withDefaultReducers = withDefaultReducers;

/***/ }),

/***/ "./src/lib/handleStateArray.js":
/*!*************************************!*\
  !*** ./src/lib/handleStateArray.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleInitialStateArray = void 0;

var _flip2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/flip */ "ramda/src/flip"));

var _curry2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/curry */ "ramda/src/curry"));

var _utils =
/*#__PURE__*/
__webpack_require__(/*! ./utils */ "./src/lib/utils.js");

var _utils2 =
/*#__PURE__*/
__webpack_require__(/*! ./utils.array */ "./src/lib/utils.array.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleInitialStateArray =
/*#__PURE__*/
(0, _curry2.default)(function (opts, initialState, modelName) {
  return {
    concat: _utils2._concat,
    concatTo: (0, _flip2.default)(_utils2._concat),
    filterWhere: _utils2._filter,
    insert: _utils2._insert,
    insertAll: _utils2._insertAll,
    map: _utils2._map,
    pop: _utils2._popN,
    push: _utils2._push,
    remove: _utils2._remove,
    removeAll: _utils2._removeAll,
    replace: _utils2._replace,
    reset: function reset() {
      return initialState;
    },
    'rootState/reset': function rootStateReset() {
      return initialState;
    },
    'rootState/set': function rootStateSet(state, payload) {
      return payload[modelName] ? (0, _utils._createTypedSetterFor)({
        opts: opts,
        initialState: initialState,
        modelName: modelName,
        actionName: 'rootState/set'
      })(state, payload[modelName]) : state;
    },
    set: (0, _utils._createTypedSetterFor)({
      opts: opts,
      initialState: initialState,
      modelName: modelName,
      actionName: "".concat(modelName, "/set")
    }),
    shift: _utils2._shiftN,
    unshift: _utils2._unshift
  };
});
exports.handleInitialStateArray = handleInitialStateArray;

/***/ }),

/***/ "./src/lib/handleStateObj.js":
/*!***********************************!*\
  !*** ./src/lib/handleStateObj.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleInitialStateObject = void 0;

var _reduce2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/reduce */ "ramda/src/reduce"));

var _toPairs2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/toPairs */ "ramda/src/toPairs"));

var _merge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/merge */ "ramda/src/merge"));

var _isNil2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/isNil */ "ramda/src/isNil"));

var _both2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/both */ "ramda/src/both"));

var _is2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/is */ "ramda/src/is"));

var _anyPass2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/anyPass */ "ramda/src/anyPass"));

var _type2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/type */ "ramda/src/type"));

var _equals2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/equals */ "ramda/src/equals"));

var _o2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/o */ "ramda/src/o"));

var _cond2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/cond */ "ramda/src/cond"));

var _pipe2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/pipe */ "ramda/src/pipe"));

var _applyTo2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/applyTo */ "ramda/src/applyTo"));

var _always2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/always */ "ramda/src/always"));

var _flip2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/flip */ "ramda/src/flip"));

var _curry2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/curry */ "ramda/src/curry"));

var _pluralize =
/*#__PURE__*/
__webpack_require__(/*! pluralize */ "pluralize");

var _utils =
/*#__PURE__*/
__webpack_require__(/*! ./utils */ "./src/lib/utils.js");

var _utils2 =
/*#__PURE__*/
__webpack_require__(/*! ./utils.array */ "./src/lib/utils.array.js");

var _utils3 =
/*#__PURE__*/
__webpack_require__(/*! ./utils.obj */ "./src/lib/utils.obj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: implement and test all the other convenience actions
var addArrayActions =
/*#__PURE__*/
(0, _curry2.default)(function (opts, modelName, propName, initialState) {
  var _ref;

  // using arbitrary readable names for distinguishing singular and plural
  var People = (0, _utils._toTitle)(propName);
  var Person = (0, _utils._toTitle)((0, _pluralize.singular)(People)); //
  // ─── ACTIONS ────────────────────────────────────────────────────────────────────
  //

  var _concat_ = (0, _utils._toPropSetter)(propName, _utils2._concat);

  var _concatTo_ = (0, _utils._toPropSetter)(propName, (0, _flip2.default)(_utils2._concat));

  var _filter_ = (0, _utils._toPropSetter)(propName, _utils2._filter);

  var _insert_ = (0, _utils._toPropSetter)(propName, _utils2._insert);

  var _insertAll_ = (0, _utils._toPropSetter)(propName, _utils2._insertAll);

  var _map_ = (0, _utils._toPropSetter)(propName, _utils2._map);

  var _popN_ = (0, _utils._toPropSetter)(propName, _utils2._popN);

  var _push_ = (0, _utils._toPropSetter)(propName, _utils2._push);

  var _remove_ = (0, _utils._toPropSetter)(propName, _utils2._remove);

  var _removeAll_ = (0, _utils._toPropSetter)(propName, _utils2._removeAll);

  var _replace_ = (0, _utils._toPropSetter)(propName, _utils2._replace);

  var _reset_ = (0, _utils._toPropSetter)(propName, function () {
    return initialState;
  });

  var _shiftN_ = (0, _utils._toPropSetter)(propName, _utils2._shiftN);

  var _unshift_ = (0, _utils._toPropSetter)(propName, _utils2._unshift);

  return _ref = {}, _defineProperty(_ref, "concat".concat(People), _concat_), _defineProperty(_ref, "concat".concat(People, "To"), _concatTo_), _defineProperty(_ref, "filter".concat(People, "Where"), _filter_), _defineProperty(_ref, "insert".concat(Person), _insert_), _defineProperty(_ref, "insert".concat(People), _insertAll_), _defineProperty(_ref, "map".concat(People), _map_), _defineProperty(_ref, "pop".concat(People), _popN_), _defineProperty(_ref, "push".concat(Person), _push_), _defineProperty(_ref, "remove".concat(Person), _remove_), _defineProperty(_ref, "remove".concat(People), _removeAll_), _defineProperty(_ref, "replace".concat(Person), _replace_), _defineProperty(_ref, "reset".concat(People), _reset_), _defineProperty(_ref, "set".concat(People), (0, _utils._createTypedPropSetterFor)(opts, initialState, modelName, propName)), _defineProperty(_ref, "shift".concat(People), _shiftN_), _defineProperty(_ref, "unshift".concat(People), _unshift_), _ref;
});
var addObjActions =
/*#__PURE__*/
(0, _curry2.default)(function (opts, modelName, propName, initialState) {
  var _ref2;

  var PropName = (0, _utils._toTitle)(propName);

  if (!opts.allowNil && (0, _utils._hasNilKeysDeep)(initialState)) {
    return (0, _utils._handleNil)("".concat(modelName, ".").concat(propName), initialState);
  }

  return _ref2 = {}, _defineProperty(_ref2, "reset".concat(PropName), (0, _utils._toPropSetter)(propName, function () {
    return initialState;
  })), _defineProperty(_ref2, "set".concat(PropName), (0, _utils._createTypedPropSetterFor)(opts, initialState, modelName, propName)), _ref2;
});
var addOtherTypeActions =
/*#__PURE__*/
(0, _curry2.default)(function (opts, modelName, propName, initialState) {
  var _ref3;

  var PropName = (0, _utils._toTitle)(propName);
  return _ref3 = {}, _defineProperty(_ref3, "reset".concat(PropName), (0, _utils._toPropSetter)(propName, function () {
    return initialState;
  })), _defineProperty(_ref3, "set".concat(PropName), (0, _utils._createTypedPropSetterFor)(opts, initialState, modelName, propName)), _ref3;
});
var fromPairsAccumActionsFor =
/*#__PURE__*/
(0, _curry2.default)(function (modelName, opts) {
  return function _accumActions(accum, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        propName = _ref5[0],
        initialState = _ref5[1];

    var nilIsNotAllowed = (0, _always2.default)(!opts.allowNil);
    return (0, _applyTo2.default)(initialState)((0, _pipe2.default)((0, _cond2.default)([[_utils3.isVanillaObj, addObjActions(opts, modelName, propName)], [(0, _o2.default)((0, _equals2.default)('Array'), _type2.default), addArrayActions(opts, modelName, propName)], [(0, _anyPass2.default)([(0, _is2.default)(String), (0, _is2.default)(Boolean), (0, _is2.default)(Number)]), addOtherTypeActions(opts, modelName, propName)], [(0, _both2.default)(nilIsNotAllowed, _isNil2.default), (0, _utils._handleNil)("".concat(modelName, ".").concat(propName))], [(0, _always2.default)(true), addOtherTypeActions(opts, modelName, propName)]]), (0, _merge2.default)(accum)));
  };
});
/**
 * :: (model, modelName) -> Object(reducers)
 */

var handleInitialStateObject =
/*#__PURE__*/
(0, _curry2.default)(function (opts, initialState, modelName) {
  return (0, _applyTo2.default)(initialState)((0, _pipe2.default)(_toPairs2.default, (0, _reduce2.default)(fromPairsAccumActionsFor(modelName, opts), {}), (0, _merge2.default)({
    reset: function reset() {
      return initialState;
    },
    'rootState/reset': function rootStateReset() {
      return initialState;
    },
    'rootState/set': function rootStateSet(state, payload) {
      return payload[modelName] ? (0, _utils._createTypedSetterFor)({
        opts: opts,
        initialState: initialState,
        modelName: modelName,
        actionName: 'rootState/set'
      })(state, payload[modelName]) : state;
    },
    set: (0, _utils._createTypedSetterFor)({
      opts: opts,
      initialState: initialState,
      modelName: modelName,
      actionName: "".concat(modelName, "/set")
    })
  })));
});
exports.handleInitialStateObject = handleInitialStateObject;

/***/ }),

/***/ "./src/lib/handleStatePrimitives.js":
/*!******************************************!*\
  !*** ./src/lib/handleStatePrimitives.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleInitialStateOther = void 0;

var _equals2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/equals */ "ramda/src/equals"));

var _not2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/not */ "ramda/src/not"));

var _type2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/type */ "ramda/src/type"));

var _merge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/merge */ "ramda/src/merge"));

var _mapObjIndexed2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/mapObjIndexed */ "ramda/src/mapObjIndexed"));

var _applyTo2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/applyTo */ "ramda/src/applyTo"));

var _curry2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/curry */ "ramda/src/curry"));

var _utils =
/*#__PURE__*/
__webpack_require__(/*! ./utils */ "./src/lib/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _guardTypes =
/*#__PURE__*/
(0, _curry2.default)(function (opts, reducers, initialState, modelName) {
  return (0, _applyTo2.default)(reducers)((0, _mapObjIndexed2.default)(function (reducer, reducerName) {
    return function (state, payload, meta) {
      var _R$merge = (0, _merge2.default)(opts, meta),
          typeCheck = _R$merge.typeCheck;

      var initialStateType = (0, _type2.default)(initialState);
      var result = reducer(state, payload);

      if (typeCheck && (0, _not2.default)((0, _equals2.default)(initialStateType, (0, _type2.default)(result)))) {
        throw new TypeError("".concat(modelName, " was initialized as a(n) ").concat(initialStateType, ", but ").concat(modelName, "/").concat(reducerName, " attempted to perform an operation that would set it to a non-").concat(initialStateType, " value. You should only set your models and their properties to values of the type with which you initialize them."));
      }

      return result;
    };
  }));
});

var handleInitialStateOther =
/*#__PURE__*/
(0, _curry2.default)(function (opts, initialState, modelName) {
  var createOtherTypesReducers = _guardTypes(opts)({
    reset: function reset() {
      return initialState;
    },
    'rootState/reset': function rootStateReset() {
      return initialState;
    },
    'rootState/set': function rootStateSet(state, payload) {
      return payload[modelName] === undefined ? state : payload[modelName];
    },
    set: _utils._returnSecondArg
  });

  return createOtherTypesReducers(initialState, modelName);
});
exports.handleInitialStateOther = handleInitialStateOther;

/***/ }),

/***/ "./src/lib/utils.array.js":
/*!********************************!*\
  !*** ./src/lib/utils.array.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._unshift = exports._shiftN = exports._replace = exports._removeAll = exports._remove = exports._push = exports._popN = exports._map = exports._insertAll = exports._insert = exports._filter = exports._concat = void 0;

var _lensIndex2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/lensIndex */ "ramda/src/lensIndex"));

var _lte2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/lte */ "ramda/src/lte"));

var _ifElse2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/ifElse */ "ramda/src/ifElse"));

var _set2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/set */ "ramda/src/set"));

var _negate2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/negate */ "ramda/src/negate"));

var _o2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/o */ "ramda/src/o"));

var _flatten2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/flatten */ "ramda/src/flatten"));

var _pipe2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/pipe */ "ramda/src/pipe"));

var _identity2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/identity */ "ramda/src/identity"));

var _always2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/always */ "ramda/src/always"));

var _findIndex2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/findIndex */ "ramda/src/findIndex"));

var _addIndex2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/addIndex */ "ramda/src/addIndex"));

var _insert3 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/insert */ "ramda/src/insert"));

var _converge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/converge */ "ramda/src/converge"));

var _applyTo2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/applyTo */ "ramda/src/applyTo"));

var _omitIndexes =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda-adjunct/lib/omitIndexes */ "ramda-adjunct/lib/omitIndexes"));

var _contained =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda-adjunct/lib/contained */ "ramda-adjunct/lib/contained"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _insertWhere = function _insertWhere(state, _ref) {
  var predicate = _ref.predicate,
      payload = _ref.payload;
  return (0, _applyTo2.default)(state)((0, _converge2.default)(_insert3.default, [(0, _addIndex2.default)(_findIndex2.default)(predicate), (0, _always2.default)(payload), _identity2.default]));
};

var _insertAllWhere =
/*#__PURE__*/
(0, _pipe2.default)(_insertWhere, _flatten2.default);

var _removeWhere = function _removeWhere(state, predicate) {
  return (0, _applyTo2.default)(state)((0, _converge2.default)(_omitIndexes.default, [(0, _o2.default)(Array.of, (0, _addIndex2.default)(_findIndex2.default)(predicate)), _identity2.default]));
};

var _removeAllWhere = function _removeAllWhere(state, predicate) {
  return state.filter(function (el, i) {
    return !predicate(el, i);
  });
};

var _concat = function _concat(state, payload) {
  return _toConsumableArray(state).concat(_toConsumableArray(payload));
};

exports._concat = _concat;

var _filter = function _filter(state, predicate) {
  return state.filter(predicate);
};

exports._filter = _filter;

var _insert = function _insert(state, specs) {
  var where = specs.where,
      payload = specs.payload;
  return _insertWhere(state, {
    predicate: where,
    payload: payload
  });
};

exports._insert = _insert;

var _insertAll = function _insertAll(state, specs) {
  var where = specs.where,
      payload = specs.payload;
  return _insertAllWhere(state, {
    predicate: where,
    payload: payload
  });
};

exports._insertAll = _insertAll;

var _map = function _map(state, mapper) {
  return state.map(mapper);
};

exports._map = _map;

var _popN = function _popN(state, payload) {
  return state.slice(0, (0, _negate2.default)(payload || 1));
};

exports._popN = _popN;

var _push = function _push(state, payload) {
  return _toConsumableArray(state).concat([payload]);
};

exports._push = _push;

var _remove = function _remove(state, payload) {
  var where = payload.where;
  if (where) return _removeWhere(state, where);
  return _removeWhere(state, function (el) {
    return el === payload;
  });
};

exports._remove = _remove;

var _removeAll = function _removeAll(state, payload) {
  var where = payload.where;
  if (where) return _removeAllWhere(state, where);
  return _removeAllWhere(state, (0, _contained.default)(payload));
};

exports._removeAll = _removeAll;

var _replace = function _replace(state, _ref2) {
  var where = _ref2.where,
      payload = _ref2.payload;
  return (0, _applyTo2.default)(state)((0, _converge2.default)(_set2.default, [(0, _pipe2.default)((0, _addIndex2.default)(_findIndex2.default)(where), (0, _ifElse2.default)((0, _lte2.default)(0), _identity2.default, (0, _always2.default)(Infinity)), _lensIndex2.default), (0, _always2.default)(payload), _identity2.default]));
};

exports._replace = _replace;

var _shiftN = function _shiftN(state, payload) {
  return state.slice(payload || 1, Infinity);
};

exports._shiftN = _shiftN;

var _unshift = function _unshift(state, payload) {
  return [payload].concat(_toConsumableArray(state));
};

exports._unshift = _unshift;

/***/ }),

/***/ "./src/lib/utils.js":
/*!**************************!*\
  !*** ./src/lib/utils.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._createTypedPropSetterFor = exports._createTypedSetterFor = exports._toPropSetter = exports._returnSecondArg = exports._toTitle = exports._trace = exports._hasNilKeysDeep = exports._handleNil = void 0;

var _complement2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/complement */ "ramda/src/complement"));

var _mergeDeepRight2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/mergeDeepRight */ "ramda/src/mergeDeepRight"));

var _all2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/all */ "ramda/src/all"));

var _merge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/merge */ "ramda/src/merge"));

var _always2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/always */ "ramda/src/always"));

var _tail2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/tail */ "ramda/src/tail"));

var _head2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/head */ "ramda/src/head"));

var _toUpper2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/toUpper */ "ramda/src/toUpper"));

var _concat2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/concat */ "ramda/src/concat"));

var _converge2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/converge */ "ramda/src/converge"));

var _o2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/o */ "ramda/src/o"));

var _tap2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/tap */ "ramda/src/tap"));

var _isNil2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/isNil */ "ramda/src/isNil"));

var _any2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/any */ "ramda/src/any"));

var _flatten2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/flatten */ "ramda/src/flatten"));

var _identity2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/identity */ "ramda/src/identity"));

var _toPairs2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/toPairs */ "ramda/src/toPairs"));

var _ifElse2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/ifElse */ "ramda/src/ifElse"));

var _equals2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/equals */ "ramda/src/equals"));

var _type2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/type */ "ramda/src/type"));

var _pipe2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/pipe */ "ramda/src/pipe"));

var _where2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/where */ "ramda/src/where"));

var _both2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/both */ "ramda/src/both"));

var _map2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/map */ "ramda/src/map"));

var _curry2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/curry */ "ramda/src/curry"));

var _utils =
/*#__PURE__*/
__webpack_require__(/*! ./utils.obj */ "./src/lib/utils.obj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable-next-line fp/no-nil, better/explicit-return */
var _handleNil =
/*#__PURE__*/
(0, _curry2.default)(function (pathToState, initialState) {
  var stateString = JSON.stringify(initialState, null, '  ');
  throw new TypeError("[rematch/withDefaultReducers]: invalid initial state for ".concat(pathToState, ".\n Attempted to initialize with ").concat(stateString, "\n which contains or is null/undefined.\n\n Default reducers cannot be generated for any state initialized with null/undefined values. For this and many other reasons, models should be initialized with the exact interface/types your application expects.\n\nTo avoid this error, either replace null/undefined in your models with values of the type your application expects, or forego default reducers for any models or model properties you initialize as null by passing the option `{allowNil: true}` to `withDefaultReducers`\n\n"));
}); // prettier-ignore


exports._handleNil = _handleNil;

var _toInterfaceSpec =
/*#__PURE__*/
(0, _map2.default)(function (val) {
  return (0, _utils.isVanillaObj)(val) ? (0, _both2.default)(_utils.isVanillaObj, (0, _where2.default)(_toInterfaceSpec(val))) : (0, _pipe2.default)(_type2.default, (0, _equals2.default)((0, _type2.default)(val)));
}); // prettier-ignore


var _mapObjDeep = function _mapObjDeep(fn) {
  return (0, _map2.default)(function (val) {
    return (0, _utils.isVanillaObj)(val) ? fn(_mapObjDeep(fn)(val)) : fn(val);
  });
}; // prettier-ignore


var _hasNilKeysDeep =
/*#__PURE__*/
(0, _pipe2.default)(
/*#__PURE__*/
_mapObjDeep(
/*#__PURE__*/
(0, _ifElse2.default)(_utils.isVanillaObj, _toPairs2.default, _identity2.default)), _toPairs2.default, _flatten2.default,
/*#__PURE__*/
(0, _any2.default)(_isNil2.default)); // prettier-ignore


exports._hasNilKeysDeep = _hasNilKeysDeep;

var _describeInterface =
/*#__PURE__*/
(0, _map2.default)(function (val) {
  return (0, _utils.isVanillaObj)(val) ? _describeInterface(val) : (0, _type2.default)(val);
});

var _trace =
/*#__PURE__*/
(0, _tap2.default)(console.log);

exports._trace = _trace;

var _toTitle =
/*#__PURE__*/
(0, _ifElse2.default)(
/*#__PURE__*/
(0, _o2.default)(
/*#__PURE__*/
(0, _equals2.default)('String'), _type2.default),
/*#__PURE__*/
(0, _converge2.default)(_concat2.default, [
/*#__PURE__*/
(0, _o2.default)(_toUpper2.default, _head2.default), _tail2.default]),
/*#__PURE__*/
(0, _always2.default)(''));

exports._toTitle = _toTitle;

var _returnSecondArg = function _returnSecondArg(state, payload) {
  return payload;
};

exports._returnSecondArg = _returnSecondArg;

var _toPropSetter =
/*#__PURE__*/
(0, _curry2.default)(function (propName, setter, state, payload) {
  return _objectSpread({}, state, _defineProperty({}, propName, setter(state[propName], payload)));
});
/* eslint-disable-next-line fp/no-nil */


exports._toPropSetter = _toPropSetter;

var _createTypedSetterFor = function _createTypedSetterFor(_ref) {
  var opts = _ref.opts,
      initialState = _ref.initialState,
      modelName = _ref.modelName,
      actionName = _ref.actionName;
  return function (state, payload) {
    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _R$merge = (0, _merge2.default)(opts, meta),
        typeCheck = _R$merge.typeCheck;

    var initialType = (0, _type2.default)(initialState);
    var payloadType = (0, _type2.default)(payload);
    var isCorrectType = payloadType === initialType;

    if (!typeCheck && (0, _all2.default)(_utils.isVanillaObj)([initialState, payload])) {
      return (0, _mergeDeepRight2.default)(state, payload);
    }

    if (!typeCheck) return payload;
    if (isCorrectType && !(0, _utils.isVanillaObj)(payload)) return payload;

    if (!isCorrectType) {
      /* eslint-disable-next-line fp/no-unused-expression */
      var _payloadString = JSON.stringify(payload, null, '  ');

      throw new TypeError("[rematch/withDefaulReducers]: The `payload` of ".concat(actionName, " does not satisfy ").concat(modelName, "'s initial interface.\n\"").concat(modelName, "\" was initialized as type: ").concat(initialType, "\nBut tried to set: ").concat(_payloadString, "\n\nTo avoid this error you should initialize your models with the exact interface/types your application expects AND avoid setting values that do not satify that interface (best-practice)\nOr if you wish to disable type checking, you can:\n1.) Disable type checking on individual dispatches by passing your action dispatchers {typeCheck: false} as the 2nd (`meta`) argument.\n\tE.g. dispatch.model.action(payload, {typeCheck: false})\n2.) Disable type checking for all default reducers by passing {typeCheck: false} as an option to `withDefaultReducers`.\n\n"));
    }

    var altersInterfaceOf = (0, _complement2.default)((0, _where2.default)(_toInterfaceSpec(payload)));

    if (!altersInterfaceOf(initialState)) {
      return (0, _mergeDeepRight2.default)(state, payload);
    }

    var iface = _describeInterface(initialState);

    var initialInterface = JSON.stringify(iface, null, '  ');
    var payloadString = JSON.stringify(payload, null, '  ');
    /* eslint-disable-next-line fp/no-unused-expression */

    throw new TypeError("[rematch/withDefaulReducers]: ".concat(actionName, " attempted to alter ").concat(modelName, "'s interface by setting values that differ from those with which ").concat(modelName, " was initialized.\n\nInitial interface for ").concat(modelName, ":\n ").concat(initialInterface, "\n\n Values attempted to set:\n").concat(payloadString, "\n\nTo avoid this error you should initialize your models with the exact interface/types your application expects AND avoid setting values that do not satify that interface (best-practice)\nOr if you wish to disable type checking, you can:\n1.) Disable type checking on individual dispatches by passing your action dispatchers {typeCheck: false} as the 2nd (`meta`) argument.\n\tE.g. dispatch.model.action(payload, {typeCheck: false})\n2.) Disable type checking for all default reducers by passing {typeCheck: false} as an option to `withDefaultReducers`.\n\n"));
  };
};

exports._createTypedSetterFor = _createTypedSetterFor;

var _createTypedPropSetterFor =
/*#__PURE__*/
(0, _curry2.default)(
/* eslint-disable-next-line fp/no-nil, fp/no-unused-expression */
function (opts, initialState, modelName, propName, state, payload) {
  var meta = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  var _R$merge2 = (0, _merge2.default)(opts, meta),
      typeCheck = _R$merge2.typeCheck;

  var initialType = (0, _type2.default)(initialState);
  var isCorrectType = (0, _type2.default)(payload) === initialType;

  var setProp = _toPropSetter(propName, _returnSecondArg);

  var updateProp = _toPropSetter(propName, _mergeDeepRight2.default);

  if (!typeCheck && (0, _utils.isVanillaObj)(payload)) return updateProp(state, payload);
  if (!typeCheck) return setProp(state, payload);
  if (isCorrectType && !(0, _utils.isVanillaObj)(payload)) return setProp(state, payload);

  if (!isCorrectType && !(0, _utils.isVanillaObj)(payload)) {
    var _payloadString2 = JSON.stringify(payload, null, '  ');
    /* eslint-disable-next-line fp/no-unused-expression */


    throw new TypeError("[rematch/withDefaulReducers]: dispatch.".concat(modelName, ".set").concat(_toTitle(propName), "() attempted to set a value of a type that does not match the type with which ").concat(modelName, ".").concat(propName, " was intialized.\n\n Initial type of ").concat(modelName, ".").concat(propName, ": ").concat(initialType, ".\nValue attempted to set: ").concat(_payloadString2, "\n\nTo avoid this error you should initialize your models with the exact interface/types your application expects AND avoid setting values that do not satify that interface (best-practice)\nOr if you wish to disable type checking, you can:\n1.) Disable type checking on individual dispatches by passing your action dispatchers {typeCheck: false} as the 2nd (`meta`) argument.\n\tE.g. dispatch.model.action(payload, {typeCheck: false})\n2.) Disable type checking for all default reducers by passing {typeCheck: false} as an option to `withDefaultReducers`.\n\n"));
  }

  var altersInterfaceOf = (0, _complement2.default)((0, _where2.default)(_toInterfaceSpec(payload)));
  if (!altersInterfaceOf(initialState)) return updateProp(state, payload);

  var iface = _describeInterface(initialState);

  var initialInterface = JSON.stringify(iface, null, '  ');
  var payloadString = JSON.stringify(payload, null, '  ');
  /* eslint-disable-next-line fp/no-unused-expression */

  throw new TypeError( // prettier-ignore
  "[rematch/withDefaulReducers]: dispatch.".concat(modelName, ".set").concat(_toTitle(propName), "() attempted to alter the model's interface by setting values that differ from those with which the model was initialized.\n\nInitial interface for ").concat(modelName, ".").concat(propName, ":\n ").concat(initialInterface, "\n\n Values attempted to set:\n").concat(payloadString, "\n\nIf you wish to override type-checking in default reducers, you can:\n1.) Pass your action dispatchers {typeCheck: false} as the 2nd (`meta`) argument.\n\tE.g. dispatch.model.action(payload, {typeCheck: false})\n2. Pass {typeCheck: false} as an option to `withDefaultReducers`.\n\n"));
});

exports._createTypedPropSetterFor = _createTypedPropSetterFor;

/***/ }),

/***/ "./src/lib/utils.obj.js":
/*!******************************!*\
  !*** ./src/lib/utils.obj.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVanillaObj = void 0;

var _is2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/is */ "ramda/src/is"));

var _both2 =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda/src/both */ "ramda/src/both"));

var _isPlainObj =
/*#__PURE__*/
_interopRequireDefault(
/*#__PURE__*/
__webpack_require__(/*! ramda-adjunct/lib/isPlainObj */ "ramda-adjunct/lib/isPlainObj"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isVanillaObj =
/*#__PURE__*/
(0, _both2.default)(_isPlainObj.default,
/*#__PURE__*/
(0, _is2.default)(Object));
exports.isVanillaObj = isVanillaObj;

/***/ }),

/***/ "pluralize":
/*!****************************!*\
  !*** external "pluralize" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("pluralize");

/***/ }),

/***/ "ramda-adjunct/lib/contained":
/*!**********************************************!*\
  !*** external "ramda-adjunct/lib/contained" ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda-adjunct/lib/contained");

/***/ }),

/***/ "ramda-adjunct/lib/isPlainObj":
/*!***********************************************!*\
  !*** external "ramda-adjunct/lib/isPlainObj" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda-adjunct/lib/isPlainObj");

/***/ }),

/***/ "ramda-adjunct/lib/omitIndexes":
/*!************************************************!*\
  !*** external "ramda-adjunct/lib/omitIndexes" ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda-adjunct/lib/omitIndexes");

/***/ }),

/***/ "ramda/src/addIndex":
/*!*************************************!*\
  !*** external "ramda/src/addIndex" ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/addIndex");

/***/ }),

/***/ "ramda/src/all":
/*!********************************!*\
  !*** external "ramda/src/all" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/all");

/***/ }),

/***/ "ramda/src/always":
/*!***********************************!*\
  !*** external "ramda/src/always" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/always");

/***/ }),

/***/ "ramda/src/any":
/*!********************************!*\
  !*** external "ramda/src/any" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/any");

/***/ }),

/***/ "ramda/src/anyPass":
/*!************************************!*\
  !*** external "ramda/src/anyPass" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/anyPass");

/***/ }),

/***/ "ramda/src/applyTo":
/*!************************************!*\
  !*** external "ramda/src/applyTo" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/applyTo");

/***/ }),

/***/ "ramda/src/both":
/*!*********************************!*\
  !*** external "ramda/src/both" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/both");

/***/ }),

/***/ "ramda/src/complement":
/*!***************************************!*\
  !*** external "ramda/src/complement" ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/complement");

/***/ }),

/***/ "ramda/src/concat":
/*!***********************************!*\
  !*** external "ramda/src/concat" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/concat");

/***/ }),

/***/ "ramda/src/cond":
/*!*********************************!*\
  !*** external "ramda/src/cond" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/cond");

/***/ }),

/***/ "ramda/src/converge":
/*!*************************************!*\
  !*** external "ramda/src/converge" ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/converge");

/***/ }),

/***/ "ramda/src/curry":
/*!**********************************!*\
  !*** external "ramda/src/curry" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/curry");

/***/ }),

/***/ "ramda/src/equals":
/*!***********************************!*\
  !*** external "ramda/src/equals" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/equals");

/***/ }),

/***/ "ramda/src/findIndex":
/*!**************************************!*\
  !*** external "ramda/src/findIndex" ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/findIndex");

/***/ }),

/***/ "ramda/src/flatten":
/*!************************************!*\
  !*** external "ramda/src/flatten" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/flatten");

/***/ }),

/***/ "ramda/src/flip":
/*!*********************************!*\
  !*** external "ramda/src/flip" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/flip");

/***/ }),

/***/ "ramda/src/head":
/*!*********************************!*\
  !*** external "ramda/src/head" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/head");

/***/ }),

/***/ "ramda/src/identity":
/*!*************************************!*\
  !*** external "ramda/src/identity" ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/identity");

/***/ }),

/***/ "ramda/src/ifElse":
/*!***********************************!*\
  !*** external "ramda/src/ifElse" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/ifElse");

/***/ }),

/***/ "ramda/src/insert":
/*!***********************************!*\
  !*** external "ramda/src/insert" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/insert");

/***/ }),

/***/ "ramda/src/is":
/*!*******************************!*\
  !*** external "ramda/src/is" ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/is");

/***/ }),

/***/ "ramda/src/isNil":
/*!**********************************!*\
  !*** external "ramda/src/isNil" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/isNil");

/***/ }),

/***/ "ramda/src/lensIndex":
/*!**************************************!*\
  !*** external "ramda/src/lensIndex" ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/lensIndex");

/***/ }),

/***/ "ramda/src/lte":
/*!********************************!*\
  !*** external "ramda/src/lte" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/lte");

/***/ }),

/***/ "ramda/src/map":
/*!********************************!*\
  !*** external "ramda/src/map" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/map");

/***/ }),

/***/ "ramda/src/mapObjIndexed":
/*!******************************************!*\
  !*** external "ramda/src/mapObjIndexed" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/mapObjIndexed");

/***/ }),

/***/ "ramda/src/merge":
/*!**********************************!*\
  !*** external "ramda/src/merge" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/merge");

/***/ }),

/***/ "ramda/src/mergeDeepRight":
/*!*******************************************!*\
  !*** external "ramda/src/mergeDeepRight" ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/mergeDeepRight");

/***/ }),

/***/ "ramda/src/negate":
/*!***********************************!*\
  !*** external "ramda/src/negate" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/negate");

/***/ }),

/***/ "ramda/src/not":
/*!********************************!*\
  !*** external "ramda/src/not" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/not");

/***/ }),

/***/ "ramda/src/o":
/*!******************************!*\
  !*** external "ramda/src/o" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/o");

/***/ }),

/***/ "ramda/src/objOf":
/*!**********************************!*\
  !*** external "ramda/src/objOf" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/objOf");

/***/ }),

/***/ "ramda/src/pipe":
/*!*********************************!*\
  !*** external "ramda/src/pipe" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/pipe");

/***/ }),

/***/ "ramda/src/prop":
/*!*********************************!*\
  !*** external "ramda/src/prop" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/prop");

/***/ }),

/***/ "ramda/src/reduce":
/*!***********************************!*\
  !*** external "ramda/src/reduce" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/reduce");

/***/ }),

/***/ "ramda/src/set":
/*!********************************!*\
  !*** external "ramda/src/set" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/set");

/***/ }),

/***/ "ramda/src/tail":
/*!*********************************!*\
  !*** external "ramda/src/tail" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/tail");

/***/ }),

/***/ "ramda/src/tap":
/*!********************************!*\
  !*** external "ramda/src/tap" ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/tap");

/***/ }),

/***/ "ramda/src/toPairs":
/*!************************************!*\
  !*** external "ramda/src/toPairs" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/toPairs");

/***/ }),

/***/ "ramda/src/toUpper":
/*!************************************!*\
  !*** external "ramda/src/toUpper" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/toUpper");

/***/ }),

/***/ "ramda/src/type":
/*!*********************************!*\
  !*** external "ramda/src/type" ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/type");

/***/ }),

/***/ "ramda/src/useWith":
/*!************************************!*\
  !*** external "ramda/src/useWith" ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/useWith");

/***/ }),

/***/ "ramda/src/where":
/*!**********************************!*\
  !*** external "ramda/src/where" ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("ramda/src/where");

/***/ })

/******/ });
});
//# sourceMappingURL=rematch-default-reducers.js.map